import { render, staticRenderFns } from "./SidebarActivities.vue?vue&type=template&id=4fe102ec&scoped=true&"
import script from "./SidebarActivities.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SidebarActivities.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SidebarActivities.vue?vue&type=style&index=0&id=4fe102ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe102ec",
  null
  
)

export default component.exports